export const createInitialFormData = sms => {
    return {
        ...sms,
    };
};
